import { useEffect } from 'react';
import type { Tree } from 'antd';

interface UsePopoverTreeScrollParams {
  isPopoverOpen: boolean;
  scrollToKey?: React.Key;
  parentMap: Record<React.Key, React.Key | null>;
  treeRef: React.RefObject<React.ElementRef<typeof Tree>>;
}

export const usePopoverTreeScroll = ({ isPopoverOpen, scrollToKey, treeRef }: UsePopoverTreeScrollParams) => {
  useEffect(() => {
    if (!isPopoverOpen || !scrollToKey || !treeRef.current) {
      return;
    }

    // Use requestAnimationFrame to ensure DOM updates are complete
    // This waits for the next paint cycle when tree nodes are rendered
    const frameId = requestAnimationFrame(() => {
      if (treeRef.current) {
        treeRef.current.scrollTo({ key: scrollToKey, align: 'top', offset: 60 });
      }
    });

    return () => cancelAnimationFrame(frameId);
  }, [isPopoverOpen, scrollToKey, treeRef]);
};
